import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Box, Divider, Notification, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import Table from './components/table';
import SectionHeading from '../sectionHeading';

const HardwarePowerfleet = ({
  hardwareList = [],
  contentfulError,
  isRenewal,
  viewType,
  ratePlans,
  hardware,
  setHardware,
  total,
  setTotal,
  error,
  headerText,
  fieldType
}) => {

  const accessories = hardwareList.filter(item =>
      _.get(item, 'fields.isAccessory', false)
    );

  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          Error fetching hardware data from contentful
        </Notification>
      )}

      {!contentfulError && hardwareList && hardwareList.length > 0 && (
        <>
          <StackView space={3}>
            <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{headerText}</Typography></SectionHeading>
            {accessories.length > 0 && (
              <Table
                type="ACCESSORY"
                isRenewal={isRenewal}
                viewType={viewType}
                ratePlans={ratePlans}
                hardware={hardware}
                setHardware={setHardware}
                list={accessories}
                total={total}
                setTotal={setTotal}
                fieldType={fieldType}
              />
            )}
            {error && (
              <Notification variant={{ validation: 'error' }}>
                {Array.isArray(error)
                  ? error.map(msg => <div>{msg}</div>)
                  : error}
              </Notification>
            )}
          </StackView>

          <Divider space={3} variant={{ inverse: true }} />
        </>
      )}
    </>
  );
};

HardwarePowerfleet.propTypes = {
  hardwareList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contentfulError: PropTypes.shape({}).isRequired,
  isRenewal: PropTypes.bool.isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.shape({}).isRequired,
  hardware: PropTypes.shape({}).isRequired,
  setHardware: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  fieldType: PropTypes.string.isRequired
};

export default HardwarePowerfleet;
